// toolDescriptors.js — UNIFIED tool-descriptor registry (E3-WS3-T04). @arch:pure-engine.
//
// ONE place for per-tool metadata (mutating / terminal / pathArgKeys), closing the
// "alias-hole": before this, MUTATING_TOOLS, TERMINAL_TOOLS and the write_file/apply_edit
// path-arg alias set lived in 3 separate spots, so adding a tool meant editing each — and a
// missed edit was silent. Now those DERIVE from this map.
//
// Lives in loop/ (framework-free) so the toolGuardrail (a pure engine) can import it WITHOUT
// pulling the agentTools executor graph (which the agentLoop tests partial-mock). agentTools.js
// re-exports these for back-compat.

export const PATH_ARG_KEYS = Object.freeze(['path', 'filePath', 'file', 'filename']);

export const TOOL_DESCRIPTORS = Object.freeze({
  run_command:        { mutating: true,  terminal: false, pathArgKeys: [] },
  read_file:          { mutating: false, terminal: false, pathArgKeys: PATH_ARG_KEYS },
  write_file:         { mutating: true,  terminal: false, pathArgKeys: PATH_ARG_KEYS },
  apply_edit:         { mutating: true,  terminal: false, pathArgKeys: PATH_ARG_KEYS },
  list_files:         { mutating: false, terminal: false, pathArgKeys: ['path'] },
  grep_search:        { mutating: false, terminal: false, pathArgKeys: [] },
  semantic_search:    { mutating: false, terminal: false, pathArgKeys: [] },
  search_brain:       { mutating: false, terminal: false, pathArgKeys: [] },
  present_plan:       { mutating: false, terminal: true,  pathArgKeys: [] },
  update_todo:        { mutating: false, terminal: false, pathArgKeys: [] },
  // Wave-A harness — feature list imutável (.apolo/features.json): create-only + status-only.
  // Mutating (escrevem no workspace) mas SEM pathArgKeys: o path é fixo, não vem de arg.
  write_feature_list:    { mutating: true, terminal: false, pathArgKeys: [] },
  update_feature_status: { mutating: true, terminal: false, pathArgKeys: [] },
  preview_console:    { mutating: false, terminal: false, pathArgKeys: [] },
  preview_inspect:    { mutating: false, terminal: false, pathArgKeys: [] },
  preview_screenshot: { mutating: false, terminal: false, pathArgKeys: [] },
});

export const MUTATING_TOOLS = new Set(
  Object.entries(TOOL_DESCRIPTORS).filter(([, d]) => d.mutating).map(([n]) => n),
);

export const TERMINAL_TOOLS = new Set(
  Object.entries(TOOL_DESCRIPTORS).filter(([, d]) => d.terminal).map(([n]) => n),
);

/** Resolve the path-bearing arg of a tool call, using its descriptor's alias set. Null if none. */
export function resolvePathArg(toolName, args) {
  const d = TOOL_DESCRIPTORS[String(toolName ?? '')];
  if (!d || !args || typeof args !== 'object') return null;
  for (const k of d.pathArgKeys) {
    if (typeof args[k] === 'string') return args[k];
  }
  return null;
}
